import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FeaturedVideoSection.css';

const FeaturedVideoSection = () => {
  const navigate = useNavigate();
  
  // HARDCODE VIDEO - REPLACE WITH YOUR VIDEO URL
  const VIDEO_URL = 'videos/shop_intro.mp4';
  const POSTER_URL = 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=400&h=700&fit=crop';

  return (
    <section className="featured-video-section">
      <div className="container-modern">
        <div className="featured-video-inner">
          <div className="featured-video-content">
            <div className="video-badge">TCNAILS DEPOT</div>
            <h2 className="video-title">Your Trusted Nail Supply Distributor</h2>
            <p className="video-subtitle">
              TCNails Depot is the trusted partner for thousands of salons nationwide. 
              We provide a complete range of authentic nail products at the best wholesale prices.
            </p>
            <div className="video-features">
              <div className="video-feature-item">
                <span className="feature-icon">💰</span>
                <span>Best Wholesale Prices - Save Up to 40%</span>
              </div>
              <div className="video-feature-item">
                <span className="feature-icon">🎨</span>
                <span>10,000+ Diverse Styles & Colors</span>
              </div>
              <div className="video-feature-item">
                <span className="feature-icon">✅</span>
                <span>100% Authentic - 10+ Years Trusted</span>
              </div>
              <div className="video-feature-item">
                <span className="feature-icon">🚚</span>
                <span>Fast Nationwide Shipping</span>
              </div>
            </div>
            <div className="video-cta-group">
              <button 
                className="btn-primary-video" 
                onClick={() => navigate('/products')}
              >
                Shop All Products
                <span className="btn-arrow">→</span>
              </button>
            </div>
          </div>

          <div className="featured-video-wrapper">
            <div className="video-phone-frame">
              <video
                src={VIDEO_URL}
                poster={POSTER_URL}
                loop
                muted
                autoPlay
                playsInline
                className="featured-tiktok-video"
              />
              <div className="video-glow-ring"></div>
            </div>
            <div className="video-decor-sparkle video-sparkle-1">⭐</div>
            <div className="video-decor-sparkle video-sparkle-2">⭐</div>
            <div className="video-decor-sparkle video-sparkle-3">⭐</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedVideoSection;